import AxiosInstance from './index';
import {
  SUPER_ADMIN_TENANTS,
  SUPER_ADMIN_TENANT_BY_ID,
  SUPER_ADMIN_TENANT_STATUS,
} from '../routes/superAdminTenants';
import {
  mapTenantFromApi,
  mapTenantListResponse,
  toCreateTenantPayload,
  toUpdateTenantPayload,
  toStatusPayload,
} from '../../utils/tenantMappers';
import { extractTenantError } from '../../utils/tenantErrors';

function withTenantError(handler) {
  return async (...args) => {
    try {
      return await handler(...args);
    } catch (error) {
      throw extractTenantError(error);
    }
  };
}

function withTenantId(pathTemplate, tenantId) {
  return pathTemplate.replace(':tenantId', tenantId);
}

export const listTenants = withTenantError(async () => {
  const response = await AxiosInstance.get(SUPER_ADMIN_TENANTS);
  return mapTenantListResponse(response?.data);
});

export const createTenant = withTenantError(async (values) => {
  const response = await AxiosInstance.post(
    SUPER_ADMIN_TENANTS,
    toCreateTenantPayload(values),
  );

  return {
    tenant: mapTenantFromApi(response?.data?.tenant),
    adminUser: response?.data?.adminUser || null,
  };
});

export const updateTenant = withTenantError(async (tenantId, values) => {
  const response = await AxiosInstance.patch(
    withTenantId(SUPER_ADMIN_TENANT_BY_ID, tenantId),
    toUpdateTenantPayload(values),
  );

  return {
    tenant: mapTenantFromApi(response?.data?.tenant),
  };
});

export const setTenantStatus = withTenantError(async (tenantId, status) => {
  const response = await AxiosInstance.patch(
    withTenantId(SUPER_ADMIN_TENANT_STATUS, tenantId),
    toStatusPayload(status),
  );

  return {
    tenant: mapTenantFromApi(response?.data?.tenant),
  };
});
